import { Comment } from "../models/Comment";
import { clean } from "../utils/utils";
import api from "./api";

const API_BASE_URL = "/api/v1/comments"; // adjust if needed

export const CommentService = {
  async getComment(commentId: string): Promise<Comment | null> {
    try {
      const res = await api.get(`${API_BASE_URL}/${commentId}`);
      return res.data?.data ?? null;
    } catch (err) {
      console.error("Error fetching comment:", err);
      return null;
    }
  },

  async getAllComments(): Promise<Comment[]> {
    try {
      const res = await api.get(`${API_BASE_URL}/comments`);
      return res.data?.data ?? [];
    } catch (err) {
      console.error("Error fetching comments:", err);
      return [];
    }
  },

  async createComment(
    commentData: Omit<Comment, "_id" | "createdAt" | "updatedAt">,
  ): Promise<string> {
    const cleanData = clean(commentData);
    const res = await api.post(`${API_BASE_URL}`, cleanData);
    return res.data?.data?._id;
  },

  async createReply(
    commentRefPath: string,
    replyData: Omit<
      Comment,
      "_id" | "createdAt" | "updatedAt" | "createdBy" | "updatedBy"
    >,
  ): Promise<string> {
    const res = await api.post(
      `${API_BASE_URL}/${commentRefPath}/replies`,
      replyData,
    );
    return res.data?.data?._id;
  },

  async updateComment(
    commentId: string,
    updatedData: Partial<Omit<Comment, "_id" | "createdAt">>,
  ): Promise<void> {
    await api.patch(`${API_BASE_URL}/${commentId}`, {
      ...clean(updatedData),
    });
  },

  async deleteComment(commentId: string): Promise<void> {
    await api.delete(`${API_BASE_URL}/${commentId}`);
  },
};
